<template>
  <div class="sidebar-logo-container" :class="{ collapse: collapse }">
    <transition name="sidebarLogoFade">
      <router-link
        v-if="collapse"
        key="collapse"
        class="sidebar-logo-link"
        to="/backstage"
      >
        <img v-if="logo" :src="logo" class="sidebar-logo" alt="Login" />
        <h1 v-else class="sidebar-title">{{ $t("app.appName") }}</h1>
      </router-link>
      <router-link
        v-else
        key="expand"
        style="padding: 0 20px;"
        class="sidebar-logo-link"
        to="/backstage"
      >
        <img v-if="logo" :src="logo" class="sidebar-logo" alt="Login" />
        <h1 class="sidebar-title">
          {{ $t("app.appName") }}
        <p class="version" style="color:#66FF00">{{ version }}</p>
        </h1>
      </router-link>
    </transition>
  </div>
</template>

<script>
import { config } from "@/config/global_config";
export default {
  name: "SidebarLogo",
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      logo: require("../../assets/logo.png"),
      version: config.version
    };
  }
};
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  /*height: 60px;*/
   line-height: 20px;
  // min-height: 60px;
  background: #303133;
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    /*height: 100%;*/
    width: 100%;

    & .sidebar-logo {
      width: 32px;
      height: 32px;
      vertical-align: middle;
      margin-right: 12px;
    }

    & .sidebar-title {
      display: inline;
      margin: 0;
      color: #fff;
      font-weight: 600;
      line-height: 50px;
      font-size: 14px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
      .version {
        font-weight: bold;
        font-size: 20px;
        line-height: 20px;
      }
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>
